// extracted by mini-css-extract-plugin
module.exports = {"heading":"Governance_heading__MOhD3","subheading":"Governance_subheading__222R0"};